import * as claimService from "../../services/httpEndpoint"

export const UPDATE_FROM_GETDATA = "UPDATE_FROM_GETDATA"
export const UPDATE_VALID_FORM_DATA = "UPDATE_VALID_FORM_DATA"
export const UPDATE_CLAIM_DATA = "UPDATE_CLAIM_DATA"
export const PAGE_CLICKED_NEXT_UPDATE = "PAGE_CLICKED_NEXT_UPDATE"
export const CONTROL_LOADING = "CONTROL_LOADING"
export const CONTROL_EDIT_BENEFIT = "CONTROL_EDIT_BENEFIT"
export const UPDATE_UI_DATA = "UPDATE_UI_DATA"
export const SELECT_DOCUMENT = "SELECT_DOCUMENT"
export const RESET_SELECT_DOCUMENT = "RESET_SELECT_DOCUMENT"
export const RESET_PET_LOSS = "RESET_PET_LOSS"
export const ADD_FILE_TO_LIST = "ADD_FILE_TO_LIST"
export const REMOVE_FILE_FROM_LIST = "REMOVE_FILE_FROM_LIST"
export const CHECKBOX_STATUS_UPDATE = "CHECKBOX_STATUS_UPDATE"
export const CONTROL_DECLARATION = "CONTROL_DECLARATION"
export const EDIT_ALL_INVALID_FORM = "EDIT_ALL_INVALID_FORM"
export const EDIT_UPLOAD = "EDIT_UPLOAD"
export const UPDATE_DOCUMENT_MANDATORY = "UPDATE_DOCUMENT_MANDATORY"
export const UPDATE_DOCUMENT_VISIBLE = "UPDATE_DOCUMENT_VISIBLE"
export const REMOVE_FROM_DOCUMENT_LIST = "REMOVE_FROM_DOCUMENT_LIST"
export const GET_REQUIRED_DOCUMENTS = "GET_REQUIRED_DOCUMENTS"
export const UPDATE_DROPDOWN = "UPDATE_DROPDOWN"
export const ADD_BENEFIT_ITEM = "ADD_BENEFIT_ITEM"

export const updateFromGetData = (targetModal, newData) => {
  return {
    type: UPDATE_FROM_GETDATA,
    targetModal,
    newData,
  }
}

export const updateValidFormData = (targetModal, newData) => {
  return {
    type: UPDATE_VALID_FORM_DATA,
    targetModal,
    newData,
  }
}

export const updateClaimData = (targetModal, newData) => {
  return {
    type: UPDATE_CLAIM_DATA,
    targetModal,
    newData,
  }
}

export const updateClickedNext = (currentPageNumber, changes) => {
  return {
    type: PAGE_CLICKED_NEXT_UPDATE,
    currentPageNumber,
    changes,
  }
}

export const controlLoading = () => {
  return {
    type: CONTROL_LOADING,
  }
}

export const updateUiData = (property, newData) => {
  return {
    type: UPDATE_UI_DATA,
    property,
    newData,
  }
}

export const selectDocument = (documentId, documentDesc) => {
  return {
    type: SELECT_DOCUMENT,
    documentId,
    documentDesc,
  }
}

export const resetSelectDocument = () => {
  return {
    type: RESET_SELECT_DOCUMENT,
  }
}

export const resetPetLossDetail = () => {
  return {
    type: RESET_PET_LOSS,
  }
}

export const addFileToList = (
  fileName,
  documentId,
  filePath,
  fileSize,
  folderName,
  compressedFilesize
) => {
  return {
    type: ADD_FILE_TO_LIST,
    fileName,
    documentId,
    filePath,
    fileSize,
    folderName,
    compressedFilesize: compressedFilesize,
  }
}

export const removeFileFromList = (fileName, fileSize) => {
  return {
    type: REMOVE_FILE_FROM_LIST,
    fileName,
    fileSize,
  }
}

export const controlEditBenefit = formName => {
  return {
    type: CONTROL_EDIT_BENEFIT,
    formName,
  }
}

export const checkboxStatusUpdate = checkboxName => {
  return {
    type: CHECKBOX_STATUS_UPDATE,
    checkboxName,
  }
}

export const controlDeclaration = () => {
  return {
    type: CONTROL_DECLARATION,
  }
}

export const editAllInvalidForm = formlist => {
  return {
    type: EDIT_ALL_INVALID_FORM,
    formlist,
  }
}

export const editUpload = () => {
  return {
    type: EDIT_UPLOAD,
  }
}

export const updateDocumentMandatory = (targetDocumentId, updatedValue) => {
  return {
    type: UPDATE_DOCUMENT_MANDATORY,
    targetDocumentId,
    updatedValue,
  }
}

export const updateDocumentVisible = (targetDocumentId, updatedValue) => {
  return {
    type: UPDATE_DOCUMENT_VISIBLE,
    targetDocumentId,
    updatedValue,
  }
}

export const removeFromDocumentList = targetDocumentId => {
  return {
    type: REMOVE_FROM_DOCUMENT_LIST,
    targetDocumentId,
  }
}

export const submitClaim = (claimData, uiData) => {
  return dispatch => dispatch(claimService.SubmitClaim(claimData, uiData))
}

export const getRequiredDocuments = coverageDetailId => {
  return dispatch =>
    dispatch(claimService.GetRequiredDocuments(coverageDetailId))
}

export const getDropdownData = tableName => {
  return dispatch => dispatch(claimService.GetDropdownData(tableName))
}

export const getNationalityData = () => {
  return dispatch => dispatch(claimService.GetNationalityData())
}

export const getBankListData = () => {
  return dispatch => dispatch(claimService.GetBankListData())
}

export const getPolicyInfo = getPolicyInfoRequestModel => {
  return dispatch =>
    dispatch(claimService.GetPolicyInfo(getPolicyInfoRequestModel))
}

export const calculateCoinsuranceRate = (petDateofBirth, policyStartDate) => {
  return dispatch =>
    dispatch(claimService.CalculateCoinsuranceRate(petDateofBirth, policyStartDate))
}

export const updateDropdown = (dropdownName, dropdownItems) => {
  return {
    type: UPDATE_DROPDOWN,
    dropdownName,
    dropdownItems,
  }
}

export const addBenefitItem = (targetModal, newItemList) => {
  return {
    type: ADD_BENEFIT_ITEM,
    targetModal,
    newItemList,
  }
}
